import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import API from "../pages/Services/Baseservice";
import { LanguageContext } from "../pages/languagecontext";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import ClipLoader from "react-spinners/ClipLoader";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

const BookingForm = () => {
  const { selectedLanguage } = useContext(LanguageContext);
  const [startDate, setStartDate] = React.useState(null);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [immigrationErr, setImmigrationErr] = useState("");
  const [consultationErr, setConsultationErr] = useState("");
  const [startDateErr, setStartDateErr] = useState("");
  const [timeErr, setTimeErr] = useState("");
  const [loading, setLoading] = useState(true);
  const [slotloading, setSlotLoading] = useState(true);
  const [listimmigratongoal, setImmigrationGoal] = useState([]);
  const [immigrationvalue, setimmigration] = useState("");
  const [consultationtype, setConsultationType] = useState([]);
  const [hadleType, setHandleType] = useState("");
  const [bookedRanges, setBookedRanges] = useState([]);
  const [timeList, setTimeList] = useState([]);
  const location = useLocation();
  const [activeStartTime, setActiveStartTime] = useState(null);
  const languageChangedRef = useRef(false);
  const prevLanguageRef = useRef(selectedLanguage.id);
  const immigrationRef = useRef(null);
  const consultationRef = useRef(null);
  const dateRef = useRef(null);
  const timeRef = useRef(null);
  const [selectedOurServiceId, setSelectedOurServiceId] = useState("");
  const isRestoringRef = useRef(false);
  const navigate = useNavigate();
  dayjs.extend(utc);
  dayjs.extend(timezone);

  useEffect(() => {
    const navigatedBack = sessionStorage.getItem("navigated_from_step2");

    if (navigatedBack) {
      // Coming back from step 2 — keep session data for restore
      sessionStorage.removeItem("navigated_from_step2");
    } else {
      // Fresh load or refresh — clear booking data
      sessionStorage.removeItem("booking_step1_data");
      sessionStorage.removeItem("booking_step2_data");
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const home = () => {
    navigate("/");
  };

  const handleStartTime = (item) => {
    if (!item) return;

    setStartTime(item.start_time);
    setEndTime(item.end_time);
    setTimeErr("");
  };
  useEffect(() => {
    if (isRestoringRef.current) {
      isRestoringRef.current = false;
      return;
    }

    setStartTime("");
    setEndTime("");
    setActiveStartTime(null);
  }, [hadleType, startDate]);
  const goToStep2 = () => {
    const selectedService = listimmigratongoal.find(
      (item) => String(item.listofservice_id) === String(immigrationvalue),
    );

    sessionStorage.setItem("navigated_from_step2", "true");

    sessionStorage.setItem(
      "booking_step1_data",
      JSON.stringify({
        languageId: selectedLanguage.id,
        immigrationvalue,
        selectedOurServiceId: selectedService?.ourservice_id || "",
        serviceHeading: selectedService?.heading || "",
        hadleType,
        bookingdate: startDate ? startDate.format("YYYY-MM-DD") : null,
        startTime,
        endTime,
      }),
    );

    navigate("/bookingintakeform", {
      state: {
        consultation_type_id: hadleType,
        listofservice_id: immigrationvalue,
        bookingdate: startDate ? startDate.format("YYYY-MM-DD") : null,
        starttime: startTime,
        endtime: endTime,
        serviceHeading: selectedService?.heading || "",
      },
    });
  };
  const BookConsultation = () => {
    setImmigrationErr("");
    setConsultationErr("");
    setStartDateErr("");
    setTimeErr("");

    if (!immigrationvalue) {
      const msg =
        selectedLanguage.id === 1
          ? "Immigration Goal Is Required"
          : "L'objectif d'immigration est obligatoire";
      setImmigrationErr(msg);
      immigrationRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }

    if (!hadleType) {
      const msg =
        selectedLanguage.id === 1
          ? "Consultation Type Is Required"
          : "Le type de consultation est obligatoire";
      setConsultationErr(msg);
      consultationRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }

    if (!startDate) {
      const msg =
        selectedLanguage.id === 1
          ? "Date Is Required"
          : "La date est obligatoire";
      setStartDateErr(msg);
      dateRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (!startTime) {
      const msg =
        selectedLanguage.id === 1
          ? "Please select a time slot"
          : "Veuillez sélectionner un créneau horaire";
      setTimeErr(msg);
      timeRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    goToStep2();
  };

  // useEffect(() => {
  //   if (location.state?.listofservice_id &&
  //     listimmigratongoal.length > 0 &&
  //     !immigrationvalue) {
  //     const serviceId = String(location.state.listofservice_id);
  //     setimmigration(serviceId);
  //   }
  // }, [location.state?.listofservice_id, listimmigratongoal, immigrationvalue]);

  // useEffect(() => {
  //   const prevLang = prevLanguageRef.current;
  //   const currentLang = selectedLanguage.id;

  //   // ✅ Skip first render
  //   if (prevLang === currentLang) return;

  //   // ✅ Only clear if language actually changed
  //   sessionStorage.removeItem("booking_step1_data");
  //   sessionStorage.removeItem("booking_step2_data");

  //   setimmigration("");
  //   setHandleType("");
  //   setStartDate(null);
  //   setStartTime("");
  //   setEndTime("");
  //   setActiveStartTime(null);
  //   setTimeList([]);

  //   prevLanguageRef.current = currentLang;

  // }, [selectedLanguage.id]);

  useEffect(() => {
    languageChangedRef.current = false;
  }, []);
  useEffect(() => {
    if (selectedLanguage.id && immigrationvalue) {
      consultationType();
    }
  }, [selectedLanguage.id, immigrationvalue]);

  useEffect(() => {
    if (selectedLanguage.id) {
      webListOfService();
    }
  }, [selectedLanguage.id]);

  // useEffect(() => {
  //   if (selectedLanguage.id) {
  //     webListOfService()
  //     consultationType()
  //   }
  // }, [selectedLanguage.id])

  // const webListOfService = () => {

  //   setLoading(true);
  //   let req = {
  //     language_id: selectedLanguage.id
  //   }
  //   API.post("weblistofservice_list/webCondition", req).then((res) => {
  //     if (res.data.success === true) {
  //       setImmigrationGoal(res.data.data.data)
  //       setLoading(false);
  //     }
  //   })
  // }
  const webListOfService = () => {
    setLoading(true);
    const req = { language_id: selectedLanguage.id };

    API.post("weblistofservice_list/webCondition", req)
      .then((res) => {
        if (res.data.success === true) {
          const data = (res.data.data.data || [])
            .slice()
            .sort((a, b) => Number(a.order_by) - Number(b.order_by));
          setImmigrationGoal(data);

          const incomingServiceId = location.state?.listofservice_id;

          if (incomingServiceId) {
            // Came here via navigate() with a specific service — always honor it
            setHandleType("");
            setStartDate(null);
            setStartTime("");
            setEndTime("");
            setActiveStartTime(null);
            setTimeList([]);
            setimmigration(String(incomingServiceId));

            const selectedItem = data.find(
              (item) =>
                String(item.listofservice_id) === String(incomingServiceId),
            );
            setSelectedOurServiceId(selectedItem?.ourservice_id || "");
          } else {
            const saved = sessionStorage.getItem("booking_step1_data");

            if (saved) {
              const parsed = JSON.parse(saved);

              if (String(parsed.languageId) === String(selectedLanguage.id)) {
                setimmigration(String(parsed.immigrationvalue));
              } else if (parsed.selectedOurServiceId) {
                const match = data.find(
                  (item) =>
                    String(item.ourservice_id) ===
                    String(parsed.selectedOurServiceId),
                );
                setimmigration(
                  match
                    ? String(match.listofservice_id)
                    : String(data[0]?.listofservice_id || ""),
                );
              } else {
                setimmigration(String(data[0]?.listofservice_id || ""));
              }
            } else {
              // Direct/manual visit to /bookingform — no incoming id, no saved state — default to first service
              setimmigration(String(data[0]?.listofservice_id || ""));
            }
          }

          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    const saved = sessionStorage.getItem("booking_step1_data");

    if (!saved) return;

    const parsed = JSON.parse(saved);

    isRestoringRef.current = true;

    setHandleType(parsed.hadleType || "");

    setStartDate(parsed.bookingdate ? dayjs(parsed.bookingdate) : null);

    setStartTime(parsed.startTime || "");

    setEndTime(parsed.endTime || "");

    setActiveStartTime(parsed.startTime || null);
  }, []);
  const Immigration = (e) => {
    const value = e.target.value;
    if (value === immigrationvalue) return;
    setimmigration(value);
    setHandleType("");
    setStartDate(null);
    setStartTime("");
    setEndTime("");
    setActiveStartTime(null);
    setTimeList([]);

    const selectedItem = listimmigratongoal.find(
      (item) => String(item.listofservice_id) === value,
    );

    setSelectedOurServiceId(selectedItem?.ourservice_id || "");
  };

  // const consultationType = () => {
  //   let req = { language_id: selectedLanguage.id };

  //   API.post("consultationTypelist/webCondition", req).then((res) => {
  //     if (res.data.success === true && Array.isArray(res.data.data)) {
  //       setConsultationType(res.data.data);
  //     } else {
  //       setConsultationType([]);
  //     }
  //   });
  // };
  const consultationType = () => {
    let req = {
      language_id: selectedLanguage.id,
      listofservice_id: immigrationvalue,
    };

    API.post("ConsultationTypeListservice/condition", req).then((res) => {
      if (res.data.success === true && Array.isArray(res.data.data)) {
        setConsultationType(res.data.data);
      } else {
        setConsultationType([]);
      }
    });
  };

  const handleConsultationType = (e) => {
    setHandleType(e.target.value);
  };

  useEffect(() => {
    if (!hadleType || !startDate) {
      setTimeList([]);
      return;
    }

    fetchTimeList(startDate.format("YYYY-MM-DD"));
  }, [hadleType, startDate]);
  const fetchTimeList = (selectedDate) => {
    let req = {
      consultation_type_id: hadleType,
      consultation_date: selectedDate,
      user_timezone: getTimezone(),
    };
    setSlotLoading(true);
    API.post("consultationTimerSlotslist/webCondition", req)
      .then((res) => {
        if (res.data.success === true) {
          setTimeList(res.data.data);
        } else {
          setTimeList([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching time slots:", err);
        setTimeList([]);
      })
      .finally(() => {
        setSlotLoading(false);
      });
  };

  useEffect(() => {
    if (selectedLanguage && hadleType !== undefined && hadleType !== null) {
      bookingList();
    }
  }, [selectedLanguage, hadleType, startDate]);

  const getTimezone = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone;
  };

  const bookingList = () => {
    setBookedRanges([]);
    let req = {
      booking_date: startDate ? startDate.format("YYYY-MM-DD") : null,
      user_timezone: getTimezone(),
    };

    API.post("consultationBokkinglist/webCondition", req).then((res) => {
      if (res.data.success && Array.isArray(res.data.data)) {
        if (res.data.data.length === 0) {
          setBookedRanges([]);
          return;
        }

        const ranges = res.data.data.map((item) => ({
          start: toMinutes(item.start_time),
          end: toMinutes(item.end_time),
        }));

        setBookedRanges(ranges);
      } else {
        setBookedRanges([]);
      }
    });
  };

  const isTodayInUserTZ = () => {
    const today = dayjs().tz(getTimezone()).format("YYYY-MM-DD");
    return startDate?.format("YYYY-MM-DD") === today;
  };

  const getNowMinutesInUserTZ = () => {
    const now = dayjs().tz(getTimezone());
    return now.hour() * 60 + now.minute();
  };

  const isSlotDisabled = (slotStart, slotEnd) => {
    if (!slotStart || !slotEnd) return false;
    let start = toMinutes(slotStart);
    let end = toMinutes(slotEnd);

    if (end <= start) {
      end += 1440;
    }

    const isBooked = bookedRanges.some((b) => {
      let bStart = b.start;
      let bEnd = b.end;

      if (bEnd <= bStart) {
        bEnd += 1440;
      }
      return start < bEnd && end > bStart;
    });

    if (isBooked) return true;

    if (isTodayInUserTZ()) {
      let nowMinutes = getNowMinutesInUserTZ();
      if (nowMinutes < start) {
      } else {
        nowMinutes += 1440;
      }
      if (end <= nowMinutes) {
        return true;
      }
    }
    return false;
  };

  const toMinutes = (time) => {
    if (!time) return 0;
    const [h, m] = time.slice(0, 5).split(":");
    return Number(h) * 60 + Number(m);
  };

  const formatTime = (time) => time?.slice(0, 5);

  const calendarStyles = {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",

    "& .MuiPickersCalendarHeader-root": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 12px",
      marginBottom: "8px",
      position: "relative",
    },

    "& .MuiPickersCalendarHeader-labelContainer": {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      pointerEvents: "none",
    },

    "& .MuiPickersCalendarHeader-label": {
      fontSize: "18px",
      fontWeight: 600,
    },

    "& .MuiPickersArrowSwitcher-root": {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
    },

    "& .MuiPickersArrowSwitcher-button": {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      backgroundColor: "#F1F3F4",
    },

    "& .MuiPickersArrowSwitcher-button:hover": {
      backgroundColor: "#E3E5E5",
    },

    "& .MuiDayCalendar-weekDayLabelContainer": {
      display: "grid",
      gridTemplateColumns: "repeat(7, 1fr)",
      width: "100%",
    },

    "& .MuiDayCalendar-weekDayLabel": {
      width: "100%",
      textAlign: "center",
      fontSize: "14px",
      fontWeight: 500,
    },

    "& .MuiDayCalendar-weekContainer": {
      display: "grid",
      gridTemplateColumns: "repeat(7, 1fr)",
      width: "100%",
      justifyItems: "center",
    },

    "& .MuiPickersDay-root": {
      width: "40px",
      height: "40px",
      margin: "auto",
      fontSize: "21px",
      borderRadius: "50%",
      backgroundColor: "transparent",
      border: "none",
    },

    "& .MuiPickersDay-root.Mui-selected": {
      backgroundColor: "#E3E5E5",
      color: "#72777A",
      border: "none",
    },

    "& .MuiPickersDay-root.Mui-selected:focus": {
      backgroundColor: "#E3E5E5",
      outline: "none",
    },

    "& .MuiPickersDay-root:focus": {
      backgroundColor: "transparent",
      outline: "none",
    },

    "& .MuiPickersDay-root:hover": {
      backgroundColor: "#E3E5E5",
      border: "none",
    },

    "& .MuiPickersDay-dayOutsideMonth": {
      visibility: "hidden",
    },

    "& .MuiPickersSlideTransition-root": {
      overflow: "hidden",
    },
  };

  return (
    <div>
      {loading ? (
        <div
          className="d-flex justify-content-center mt-5 align-items-center p-5"
          style={{ height: "100vh" }}
        >
          <ClipLoader color="#FF050C" size={50} />
        </div>
      ) : (
        <>
          <div className="container px-3">
            <section className="faq-hero container p-4 p-lg-5 rounded-5">
              {selectedLanguage.id === 1 ? (
                <h1>Book a Consultation</h1>
              ) : (
                <h1>Réserver une consultation</h1>
              )}
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a onClick={home} style={{ cursor: "pointer" }}>
                      {selectedLanguage.id === 1 ? "Home" : "Accueil"}
                    </a>
                  </li>
                  <li className="breadcrumb-item active">
                    {selectedLanguage.id === 1
                      ? "Book a Consultation"
                      : "Réserver une consultation"}
                  </li>
                </ol>
              </nav>
            </section>
          </div>

          <div className="container py-5 mb-md-5 px-3">
            <div className="booking-wrapper row p-md-4">
              <div className="col-xxl-6 col-lg-6 ">
                <div className="section">
                  <h4 className="label mb-4">
                    {selectedLanguage.id === 1
                      ? "Select your immigration goal"
                      : "Sélectionnez votre objectif d'immigration"}
                  </h4>
                  <select
                    className="form-select custom-select"
                    value={immigrationvalue || ""}
                    onChange={Immigration}
                  >
                    <option value="">
                      {selectedLanguage.id === 1
                        ? "--Select--"
                        : "--Sélectionner--"}
                    </option>
                    {Array.isArray(listimmigratongoal) &&
                      listimmigratongoal.map((item, index) => (
                        <option
                          value={String(item.listofservice_id)}
                          key={item.listofservice_id}
                        >
                          {item.heading}
                        </option>
                      ))}
                  </select>
                  <p ref={immigrationRef} className="text-danger mt-2">
                    {immigrationErr}
                  </p>
                </div>

                <div className="section consultation-wrapper">
                  <h4 className="label mb-4">
                    {selectedLanguage.id === 1
                      ? "Consultation Type Selection"
                      : "Sélection du type de consultation"}
                  </h4>

                  {Array.isArray(consultationtype) &&
                    consultationtype.length > 0 &&
                    consultationtype.map((item) => (
                      <label
                        className="radio-row d-flex gap-2 justify-content-start"
                        key={item.consultation_type_id}
                      >
                        <input
                          type="radio"
                          name="consult"
                          value={item.consultation_type_id}
                          checked={
                            hadleType === String(item.consultation_type_id)
                          }
                          onChange={handleConsultationType}
                        />
                        <p>{item.consultation_type_name}</p>
                      </label>
                    ))}

                  <p ref={consultationRef} className="text-danger mt-2">
                    {consultationErr}
                  </p>
                </div>
              </div>

              <div className="col-xxl-6 col-lg-6">
                <div className="section">
                  <h4 className="label mb-4">
                    {selectedLanguage.id === 1
                      ? "Schedule Date & Time"
                      : "Planifier la date et l'heure"}
                  </h4>
                  <div className="calendar-box p-2 p-md-4">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateCalendar
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        views={["day"]}
                        disablePast
                        sx={calendarStyles}
                      />
                    </LocalizationProvider>
                  </div>
                  <p ref={dateRef} className="text-danger mt-2">
                    {startDateErr}
                  </p>
                </div>
              </div>
              {/* </div> 
             <div className="booking-wrapper row p-md-4">
              <div className="section col-xxl-4 col-lg-4">
                <h4 className="label mb-4">
                  {selectedLanguage.id === 1
                    ? "Select your immigration goal"
                    : "Sélectionnez votre objectif d'immigration"}
                </h4>
                <select
                  className="form-select custom-select"
                  value={immigrationvalue || ""}
                  onChange={Immigration}
                >
                  <option value="">
                    {selectedLanguage.id === 1
                      ? "--Select--"
                      : "--Sélectionner--"}
                  </option>
                  {Array.isArray(listimmigratongoal) &&
                    listimmigratongoal.map((item, index) => (
                      <option
                        value={String(item.listofservice_id)}
                        key={item.listofservice_id}
                      >
                        {item.heading}
                      </option>
                    ))}
                </select>
                <p ref={immigrationRef} className="text-danger mt-2">
                  {immigrationErr}
                </p>
              </div>

              <div className="section col-xxl-8 col-lg-8">
                <h4 className="label mb-4">
                  {selectedLanguage.id === 1
                    ? "Schedule Date & Time"
                    : "Planifier la date et l'heure"}
                </h4>
                <div className="calendar-box p-2 p-md-4">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                      value={startDate}
                      onChange={(newValue) => setStartDate(newValue)}
                      views={["day"]}
                      disablePast
                      sx={calendarStyles}
                    />
                  </LocalizationProvider>
                </div>
                <p ref={dateRef} className="text-danger mt-2">
                  {startDateErr}
                </p>
              </div> 

              <div className="section col-xxl-7">
                <h4 className="label mb-4">
                  {selectedLanguage.id === 1
                    ? "Consultation Type Selection"
                    : "Sélection du type de consultation"}
                </h4>

                {Array.isArray(consultationtype) &&
                  consultationtype.length > 0 &&
                  consultationtype.map((item) => (
                    <label
                      className="radio-row d-flex gap-2 justify-content-start"
                      key={item.consultation_type_id}
                    >
                      <input
                        type="radio"
                        name="consult"
                        value={item.consultation_type_id}
                        checked={
                          hadleType === String(item.consultation_type_id)
                        }
                        onChange={handleConsultationType}
                      />
                      <p>{item.consultation_type_name}</p>
                    </label>
                  ))}

                <p ref={consultationRef} className="text-danger mt-2">
                  {consultationErr}
                </p>
              </div>*/}

              <div className="section col-xxl-7">
                {timeList.length > 0 ? (
                  <h4 className="label mb-4">
                    {selectedLanguage.id === 1 ? "Available Time Slots" : "Créneaux horaires disponibles"}
                  </h4>
                ) : null}

                <div className="time-grid mb-4">
                  {startDate && slotloading ? (
                    <div className="d-flex justify-content-center mt-5 align-items-center">
                      <ClipLoader color="#FF050C" size={50} />
                    </div>
                  ) : startDate && timeList.length === 0 ? (
                    <div className="d-flex justify-content-center align-items-center w-100">
                      {selectedLanguage.id === 1 ? (
                        <p className="mb-0 text-danger text-center">
                          No time slots available.
                          <br />
                          Please select another date.
                        </p>
                      ) : (
                        <p className="mb-0 text-danger text-center">
                          Aucun créneau horaire disponible.
                          <br />
                          Veuillez sélectionner une autre date.
                        </p>
                      )}
                    </div>
                  ) : (
                    timeList.map((item, index) => {
                      const disabled = isSlotDisabled(
                        item.start_time,
                        item.end_time,
                      );
                      const isActive = activeStartTime === item.start_time;

                      return (
                        <button
                          key={index}
                          className={`time ${disabled ? "booked" : ""} ${isActive ? "active" : ""}`}
                          disabled={disabled}
                          onClick={() => {
                            if (!disabled) {
                              setActiveStartTime(item.start_time);
                              handleStartTime(item);
                            }
                          }}
                        >
                          {formatTime(item.start_time)}
                        </button>
                      );
                    })
                  )}
                </div>

                {timeErr && (
                  <div ref={timeRef} className="text-danger mt-1">
                    {timeErr}
                  </div>
                )}
              </div>

              <div className="footer">
                <button className="continue-btn" onClick={BookConsultation}>
                  {selectedLanguage.id === 1 ? "Continue" : "Continuer"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BookingForm;
